import AddIcon from '@mui/icons-material/Add';
import { Alert } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import { createUser } from '../../api/api-middleware';
import Modal from '../elements/Modal';
import UserForm from './UserForm';

export default function AddUser({ fetchData, setMessage, setSnackbarOpen }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const user = {
        ...values,
        role: 'user',
        platform: 'web',
      };
      let response = await createUser(user);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }
      fetchData();
      handleClose();
      setMessage('User added successfully');
      setSnackbarOpen(true)
    } catch (error) {
      setError('Failed to add a new user. ' + error.message);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <div>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}>
        New User
      </Button>
      <Modal
        open={open}
        modalTitle="Add User"
        handleClose={handleClose}
        width={'xs'}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <UserForm onSubmit={handleSubmit} />
      </Modal>
    </div>
  );
}
